<div class="wrapper">
  <sidebar-header
    [type]="tabType"
    [label]="'edit_competition' | translate"
  ></sidebar-header>
  <div class="scroll-view">
    <competition-form
      *ngIf="dataForForm$ | async as data; else loading"
      [competition]="data.competition"
      [offices]="data.offices"
      [canEditOffice]="data.canEditOffice"
      [kpiTypes]="kpiTypes"
      [observer]="proxy$"
      [mode]="competitionFormModes.EDIT_MODE"
      (submit)="onSubmit()"
    >
    </competition-form>
  </div>
  <div class="sidebar-footer">
    <app-q-button buttonType="cancel" label="cancel" (click)="closeTab()">
    </app-q-button>
    <app-q-button
      buttonType="save"
      label="save"
      (click)="competitionForm.onSubmit()"
    >
    </app-q-button>
  </div>
</div>

<ng-template #loading>
  <competition-form-skeleton></competition-form-skeleton>
</ng-template>
